<div class="container-fluid top-nav">
    <app-projectdash></app-projectdash>
    <app-projectoverview></app-projectoverview>
    <div *ngIf="userview">
        <app-projectuserview></app-projectuserview>
    </div>
    <div *ngIf="!userview">
        <app-projectslist></app-projectslist>
    </div>
    <div class="spacer"></div>
</div>